import { render, staticRenderFns } from "./StartedMatchPopup.vue?vue&type=template&id=aa61db4a&"
import script from "./StartedMatchPopup.vue?vue&type=script&lang=js&"
export * from "./StartedMatchPopup.vue?vue&type=script&lang=js&"
import style0 from "./StartedMatchPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports